export const OperacionCLGFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodOperacion: 'codOperacion',
    CodInstitutionalSales: 'codSectorComercial',
    NombreInstitutionalSales: 'nombreSectorComercial',
    FechaAprobacion: 'fechaAprobacion',
    FechaVencimiento: 'fechaVencimiento',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdMensaje: 'idMensaje',
    EstadoFinalizado: 'estadoFinalizado',
    PermiteEditar: 'permiteEditarOperacion',
    PermiteEliminar: 'permiteEliminarOperacion',
    ListaDetalles: 'detalles',
    BitEnvio: 'enviar'
} as const

export enum OperacionCLGDetalleFields {
    IdOperacion = 'idOperacion',
    IdCabecera = 'idCabeceraDetalle',
    Aforo = 'porcAforo',
    CodSeccion = 'codSeccion',
    Sector = 'seccion',
    CodEspecie = 'codEspecie',
    Especie = 'especie',
    OrdenCabecera = 'ordenCabeceraDetalle',
    OrdenSeccion = 'ordenSeccion',
    OrdenEspecie = 'ordenEspecie',
    PermiteModificar = 'permiteModificar'
}

export enum OperacionCLGLimitesAprobadosPaisFields {
    UsuarioAlta = 'usuarioUltMod',
    FechaAlta = 'fechaUltMod',
    IdMensaje = 'idMensaje',
    ListaSectores = 'sectores',
}

export enum OperacionCLGLimiteAprobadoFields {
    FechaVencimiento = 'fechaVencimiento',
    FechaAprobacion = 'fechaAprobacion',
    CodSectorComercial = 'codSectorComercial',
    NombreSectorComercial = 'nombreSectorComercial',
}

export enum OperacionCLGSectorComercialFields {
    CodSectorComercial = 'codSectorComercial',
    NombreSectorComercial = 'nombreSectorComercial',
    FechaVencimiento = 'fechaVencimiento',
    FechaAprobacion = 'fechaAprobacion',
    ListaLimites = 'limites',
}